import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=8d72850e&scoped=true"
import script from "./Bookings.vue?vue&type=script&lang=ts"
export * from "./Bookings.vue?vue&type=script&lang=ts"
import style0 from "./Bookings.vue?vue&type=style&index=0&id=8d72850e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d72850e",
  null
  
)

export default component.exports